import * as React from 'react';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import CleaningServices from '@mui/icons-material/CleaningServices';
import Edit from "@mui/icons-material/Edit";
import {Slider} from "@mui/material";

interface ActionInterface {
  icon: any,
  name: string,
  code: string
}

const marks = [

  {
    value: 1,
    label: '0%',
  },
  {
    value: 2,
    label: '100%',
  },

];

export default function ZoomSettings({zoomState, setZoomState}) {

  return (

        <Slider

          onChangeCommitted={(e, value) => {
            setZoomState(value)
          }}
          defaultValue={1}
          value={zoomState}
          valueLabelDisplay="off"
          step={0.1}
          marks={marks}
          min={1}
          max={2}
          componentsProps={{markLabel: {style: {color:"white"}}}}
        />


  );
}
